// extracted by mini-css-extract-plugin
export default {"cls1":"LvqsLmgV5wNzxj31zqb2","cls2":"CeS8xFTCBEYl9yoBzQtQ LvqsLmgV5wNzxj31zqb2"};